// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionWrapper_section__RTJJz"};